var _defs, _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 487.59 547.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #0d8afa;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m487.59,243.8v48.73L243.8,48.73,0,292.52v-48.73c0-12.93,5.14-25.33,14.28-34.48L209.32,14.28c19.04-19.04,49.91-19.04,68.96,0l195.04,195.04c9.14,9.14,14.28,21.55,14.28,34.48Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m115.97,498.44l48.76,48.76H48.76c-26.93,0-48.76-21.83-48.76-48.76v-136.95l48.76-48.76v185.71h67.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m487.59,361.49v136.95c0,26.93-21.83,48.76-48.76,48.76h-115.97l48.76-48.76h67.21v-185.71l48.76,48.76Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m226.55,143.56l-122.95,122.98v68.93l140.19-140.19,140.19,140.23v-68.96l-122.95-122.98c-9.52-9.52-24.96-9.52-34.48,0Zm17.24,344.78l-140.19-140.15v68.93l122.95,122.95c9.52,9.52,24.96,9.52,34.48,0l122.95-122.95v-68.97l-140.19,140.19Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKoto);
export default __webpack_public_path__ + "static/media/koto.055b1a51bd0f154e1d8bcc7e421dec6e.svg";
export { ForwardRef as ReactComponent };